// @flow
import React from 'react';

import { diff, now } from 'utils/dates';

// see https://github.com/audiolion/hooks
// and this discussion of this annoying problem: https://github.com/facebook/create-react-app/issues/6880
export function useMount(fn: () => any) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(fn, []);
}

export const lazy = component => { 
    // https://github.com/AlonMiz/retry-react-lazy/ 
    // "decrease of 94% in failures to fetch dynamic modules" let's see!
    const retryOnFail = async () => {
        try {
            return await component();
        } 
        catch (error) {
            const errorMessage = 'Failed to fetch dynamically imported module: ';
            let i;
            const firstTime = +now();
            let updatedTime = +now();

            for (i = 0; i < 5; i++) {
                // is 5x enough? probably with 1, 2, 4, 8, 16.. of 31 secs plus network 
                await new Promise((resolve) => setTimeout(resolve, 1000 * 2 ** i));
                const url = new URL(error.message.replace(errorMessage, "").trim());
                updatedTime = +now();
                url.searchParams.set("t", `${updatedTime}`);
                try {
                    return await import(url.href);
                } catch (e) {
                    console.info(`#${i + 1} retry`);
                }
            }
            error.stack = error.stack.concat(` (${diff(new Date(updatedTime), 'seconds', new Date(firstTime))} seconds.)`);
            throw error;
        }
    };
    return React.lazy(retryOnFail);
};
